import React, { useEffect, useState } from 'react';
// Starter admin screen; wire apiClient to your existing authenticated Axios instance.
export default function AlumniAdminPage({ apiClient }) {
  const [summary, setSummary] = useState(null), [rows, setRows] = useState([]), [q, setQ] = useState(''), [page, setPage] = useState(1), [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    Promise.all([
      apiClient.get('/api/alumni/admin/summary'), apiClient.get('/api/alumni', { params: { q, page } })
    ]).then(([s, l]) => {
      if (active) {
        setSummary(s.data);
        setRows(l.data.rows || []);
      }
    }).catch(e => {
      if (active)
        setError(e.response?.data?.error || e.message);
    });
    return () => { active = false; };
  }, [apiClient, q, page]);
  return <main style={{ padding: 20, maxWidth: 1100, margin: 'auto' }}>
    <h1 style={{ background: '#ed7d31', color: 'white', padding: 16, borderRadius: 12 }}>
      Alumni Connect
    </h1>
    {error && <p role="alert">
      {error}
    </p>}
    <section style={{ background: '#fff2e7', padding: 16, borderRadius: 12, marginTop: 16 }}>
      <h2>
        Overview
      </h2>
      <p>
        Total:
        {summary?.total ?? '—'}
        · Confirmed recently:
        {summary?.confirmedRecent ?? '—'}
        · Due:
        {summary?.due ?? '—'}
      </p>
    </section>
    <section style={{ marginTop: 20 }}>
      <h2>
        Alumni Directory (admin)
      </h2>
      <input aria-label="Search alumni" placeholder="Name or student ID" value={q} onChange={e => { setQ(e.target.value); setPage(1); }} />
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', marginTop: 12 }}>
          <thead>
            <tr>
              <th>
                Student ID
              </th>
              <th>
                Name
              </th>
              <th>
                Graduated
              </th>
              <th>
                City
              </th>
              <th>
                Last confirmed
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map(x => <tr key={x.AlumniID}>
              <td>
                {x.StudentID}
              </td>
              <td>
                {x.FullName}
              </td>
              <td>
                {x.GraduationYear}
              </td>
              <td>
                {x.CurrentCity}
              </td>
              <td>
                {x.LastConfirmedAt || 'Not confirmed'}
              </td>
            </tr>)}
          </tbody>
        </table>
      </div>
      <button onClick={() => setPage(Math.max(1, page - 1))} disabled={page === 1}>
        Previous
      </button>
      Page
      {page}
      <button onClick={() => setPage(page + 1)} disabled={rows.length < 20}>
        Next
      </button>
    </section>
  </main>;
}
